import { render, staticRenderFns } from "./DownloadOrderFormPageButton.vue?vue&type=template&id=2a73323e&scoped=true"
import script from "./DownloadOrderFormPageButton.vue?vue&type=script&lang=ts"
export * from "./DownloadOrderFormPageButton.vue?vue&type=script&lang=ts"
import style0 from "./DownloadOrderFormPageButton.vue?vue&type=style&index=0&id=2a73323e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a73323e",
  null
  
)

export default component.exports